import React from "react";
import { Avatar, Tooltip } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { css } from "./styles";

export function Icon({ tooltip_title, icon }) {
    const styles = css();

    return (
        <Tooltip title={tooltip_title}>
            <Avatar className={styles.icons}>
                <FontAwesomeIcon icon={icon} />
            </Avatar>
        </Tooltip>
    );
}
